import React from 'react'
import fillHeader from '../TableHelper'
import InputRow from './InputRow'

export const TableInput = props => {
  const genRows = data => {
    return data && data.map((row, index) => {
      let isEditable = true
      if(props.replantOrLost?.[index]?.fieldLost) {
        isEditable = false
      }
      if(props.fieldCompleteOrNot?.[index]?.isDisable && props?.fieldCompleteOrNotPage === 'harvest') {
        isEditable = false
      }
      return (
        props.editMode ? 
          isEditable &&  
        <InputRow 
          key={index}
          index={index}
          updateRowData={props.updateRowData} 
          editMode={props.editMode} 
          rowData={row}
          customStyleId={props.structure.customStyleId}
          formatting={props.structure.format} 
          last={index === (data.length - 1) && !props.structure.footers }
          replant={props.replantOrLost?.[index]?.replant}
          fieldLost={props.replantOrLost?.[index]?.fieldLost}
          isDisable={props.fieldCompleteOrNot?.[index]?.isDisable}
        /> :
          <InputRow 
            key={index}
            index={index}
            updateRowData={props.updateRowData} 
            editMode={props.editMode} 
            rowData={row}
            customStyleId={props.structure.customStyleId}
            formatting={props.structure.format} 
            last={index === (data.length - 1) && !props.structure.footers}
            replant={props.replantOrLost?.[index]?.replant}
            fieldLost={props.replantOrLost?.[index]?.fieldLost}
            isDisable={props.fieldCompleteOrNot?.[index]?.isDisable}
          />
      )
    })
  }
  let content = (
    <>
      {genRows(props.data)}
      {props.children}
    </>
  )
  if (props.statusComponent) {
    content = props.statusComponent
  }


  const genFotRow = () => {
    return (
      <InputRow 
        editMode={props.editMode} 
        rowData={props.structure.footers}
        customStyleId={props.structure.customStyleId}
        formatting={props.structure.format} 
        updateRowData={props.updateRowData} 
        last="true"
      /> 
    )
  }

  let fotContent = (
    <>
      {props.structure.footers? genFotRow(): null }
    </>
  )

  return (
    <div className={`table ${props.type}`}>
      <div className='tableHeader pl16'>
        {fillHeader(props.structure.headers)}
      </div>
      {content}
      {fotContent}
    </div>
  )
}

export default TableInput